{
  "billing": {
    "title": "Facturación",
    "notAuthorized": "Solo los propietarios del espacio pueden gestionar la facturación."
  },
  "balance": {
    "label": "Saldo de créditos",
    "credits_one": "{{count}} crédito",
    "credits_other": "{{count}} créditos",
    "available": "{{count}} disponibles",
    "breakdown": "{{purchased}} comprados · {{granted}} de regalo"
  },
  "topUp": {
    "cta": "Recargar créditos",
    "title": "Recargar créditos",
    "subtitle": "1 crédito cubre 1 perfil.",
    "payWithSaved": "Pagar {{total}} con •••• {{last4}}",
    "payNew": "Pagar {{total}}",
    "processing": "Procesando…",
    "success": "Créditos agregados",
    "genericError": "No se pudo completar el pago. Inténtalo de nuevo.",
    "settlementSlow": "Esto está tardando más de lo normal. Tu compra aparecerá pronto; revisa Facturación."
  },
  "amount": {
    "label": "¿Cuántos créditos?",
    "justEnough": "Lo justo",
    "aBitExtra": "Un poco más",
    "roundUp": "Redondear",
    "option": "{{credits}} por {{total}}"
  },
  "send": {
    "costSummary": "{{count}} invitaciones × {{unit}} = {{total}}. Tienes {{balance}} disponibles.",
    "topUpAndSend": "Recargar y enviar {{count}}"
  },
  "self": {
    "ctaHasCredits": "Perfílate (usa 1 crédito)",
    "ctaBuy": "Compra un perfil para ti — {{price}}",
    "askOwner": "Pide a un propietario del espacio que recargue créditos."
  },
  "paymentMethod": {
    "title": "Método de pago",
    "none": "No hay tarjeta registrada.",
    "card": "{{brand}} •••• {{last4}}",
    "expires": "Vence {{month}}/{{year}}",
    "replace": "Reemplazar tarjeta",
    "replaceTitle": "Reemplaza tu tarjeta",
    "replaceCta": "Guardar tarjeta",
    "replaceSuccess": "Tarjeta actualizada",
    "businessNameLabel": "Nombre de la empresa (opcional)",
    "businessNamePlaceholder": "Para facturación de empresa",
    "taxIdLabel": "Identificación fiscal (opcional)",
    "taxIdPlaceholder": "Número de IVA de la UE, si tienes uno"
  },
  "history": {
    "title": "Historial de compras",
    "empty": "Aún no hay compras.",
    "creditsColumn": "Créditos",
    "date": "Fecha",
    "amount": "Monto",
    "status": "Estado",
    "invoice": "Factura",
    "invoicePending": "Preparando…"
  }
}
